import { AppConstants } from '../constants'
import apiConfig from '../constants/apiConfig'

const paddingPrefix = (text = '', prefix) => (text.indexOf(prefix) === -1 ? prefix + text : text)

export const formatColorFromApi = (color = '') => paddingPrefix(color, '#')

export const getFullFileUrl = (url = '') => {
    return AppConstants.apiMediaUrl + '/' + apiConfig.file.download.path + paddingPrefix(url, '/');
}
